import React from "react";
import { CircularProgress, PauseIcon } from "./styles";
function CircularProgressBar({ angle }) {
  return (
    <CircularProgress angle={angle}>
      <PauseIcon />
    </CircularProgress>
  );
}

export default CircularProgressBar
